import className from 'classnames'
import css from './feed-item-ghost.scss'

const FeedItemGhost = () => (
  <div className={className(css.layout, 'mbxl')}>
    <div className={className(css.imageWrapper, 'flex center')}>
      <div className={css.shimmer} />
    </div>
    <div className={css.info}>
      <div className={className(css.type, css.bar)}>
        <div className={css.shimmer} />
      </div>
      <div className={className(css.title, css.bar)}>
        <div className={css.shimmer} />
      </div>
      <div className={className(css.teaser, css.bar)}>
        <div className={css.shimmer} />
      </div>
    </div>
  </div>
)

export default ({ className, length = 6 }) => {
  let feedItemGhosts = []

  for (let i = 0; i < length; i++) {
    feedItemGhosts.push(<FeedItemGhost key={i} />)
  }

  return <div className={className}>{feedItemGhosts}</div>
}
